import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { IBlock } from "../../../framework/src/IBlock";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import { makeApiMessage as MakeApiMessage } from "../../../components/src/common";

export const configJSON = require("./config");

export interface ISlotMasterItem {
  id: string;
  type: string;
  attributes: {
    id: number;
    threshold: number;
    activated: boolean;
    slot_type: string;
    start_time: string | null;
    end_time: string | null;
    interval_minutes: number | null;
    slots_per_day: number;
    per_slot_capacity: number;
    created_at: string;
    updated_at: string;
    mobile_service: {
      id: number;
      name: string;
      name_ar: string;
    };
    regions: Array<{ id: number; name: string }>;
    areas: Array<{ id: number; name: string }>;
    stores: Array<{ id: number; name: string }>;
    // Generated from the window, so day is always null now.
    slots: Array<{
      id: number;
      day: string | null;
      start_time: string;
      end_time: string;
      activated: boolean;
    }>;
    slot_overrides: Array<{
      id: number;
      start_date: string;
      end_date: string;
      start_time: string | null;
      end_time: string | null;
      reason: string;
      activated: boolean;
    }>;
  };
}

interface IMeta {
  current_page: number;
  total_pages: number;
  total_count: number;
  per_page: number;
  next_page: number | null;
  prev_page: number | null;
}
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: {
    navigate: Function;
    getParam: Function;
  };
  id: string;
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  slotList: Array<ISlotMasterItem>;
  isLoading: boolean;
  meta: IMeta;
  // Customizable Area End
}

export interface SS {}

class SlotManagementListController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  slotListMessageId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
    ];

    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (successResponse && requestId === this.slotListMessageId) {
      this.setState({
        isLoading: false,
        slotList: successResponse.data || [],
        meta: successResponse.meta || this.state.meta,
      });
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    this.getSlotListApi();
  }

  getSlotListApi = () => {
    this.setState({ isLoading: true });

    const requestMessage = MakeApiMessage({
      url: configJSON.ApiUrls.slotManagementList,
      method: "GET",
    });

    this.slotListMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  // Customizable Area End
}

export default SlotManagementListController;
